var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tick",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7682 14.1642L19.0448 27.4084L15.4032 23.5175C14.7323 22.885 13.6782 22.8467 12.9115 23.3834C12.164 23.9392 11.9532 24.9167 12.4132 25.7025L16.7257 32.7175C17.1473 33.3692 17.8757 33.7717 18.6998 33.7717C19.4857 33.7717 20.2332 33.3692 20.6548 32.7175C21.3448 31.8167 34.5123 16.1192 34.5123 16.1192C36.2373 14.3559 34.1482 12.8034 32.7682 14.145V14.1642Z",
    fill: "#FCAF33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.4375,
    y: 1.4375,
    width: 43.125,
    height: 43.125,
    rx: 21.5625,
    stroke: "#FCAF33",
    strokeWidth: 2.875
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.98cf51b777ab0d767c00862a443bc646.svg";
export { ForwardRef as ReactComponent };